var app = angular.module("leonardo");

var WorkFlowLaunch = function($scope, $state, $q, $controller, WorkFlowService, DynamicFormRestService, UnitTypeService,
                              AuthDataService, PermissionService, FilterService, $timeout) {
  $scope.permissionService = PermissionService;
  $scope.workflows = [];
  $scope.authDataService = AuthDataService;
  $scope.by_unit = $state.current.by_unit;
  $scope.workflows_account = [];

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
    options['by_unit'] = $scope.by_unit;
    options['ordering'] = 'account__name,name';
    if (FilterService.getFilter('account_reports')) {
      options['account'] = FilterService.getFilter('account_reports');
    }
    if (FilterService.getFilter('managed_by_reports')) {
      options['managed_by'] = FilterService.getFilter('managed_by_reports');
    }
    if (FilterService.getFilter('status')) {
      options['status'] = FilterService.getFilter('status');
    }
    if (FilterService.getFilter('name')) {
      options['name'] = FilterService.getFilter('name');
    }
    if (FilterService.getFilter('is_unit_turn')) {
      options['is_unit_turn'] = FilterService.getFilter('is_unit_turn');
    }
    if (FilterService.getFilter('unit_turn_type')) {
      options['unit_turn_type'] = FilterService.getFilter('unit_turn_type');
    }
    if (FilterService.hasFilter('role')) {
      options['roles'] = FilterService.getFilter('role');
    }
    options['without_recurrence'] = true;
    WorkFlowService.getlist(options).then(function (list) {
      $scope.workflows = list.results ? list.results : list;
      $scope.validateForbiddenMessages($scope.workflows);
      $scope.groupForAccount($scope.workflows);
      defer.resolve($scope.workflows);
    });
    return defer.promise;
  };

  $scope.groupForAccount = function (elements) {
    $scope.workflows_account = [];
    angular.forEach(elements, function (element) {
       if ($scope.getIndex(element.account) < 0) {
         $scope.workflows_account.push({id: element.account, workflows: []});
       }
       $scope.workflows_account[$scope.getIndex(element.account)].workflows.push(element);
    });
  };

  $scope.validateForbiddenMessages = function(workflows) {
    angular.forEach(workflows, function (workflow) {
      angular.forEach(workflow.templates, function (template) {
        if (template.forbidden) {
          workflow.templates_forbidden = true;
        }
      });
    });
  };

  $scope.getIndex = function(id) {
    var index = -1;
    angular.forEach($scope.workflows_account, function(value, key){
      if (value.id === id) {
        index = key;
      }
    });
    return index;
  };

  $controller('TableFilterController', { $scope: $scope });

  $timeout(function () {
    $scope.loadPage($scope.page);
  }, 0);
};

app.controller('WorkFlowLaunch', ['$scope', '$state', '$q', '$controller', 'WorkFlowService', 'DynamicFormRestService',
  'UnitTypeService', 'AuthDataService', 'PermissionService', 'FilterService', '$timeout', WorkFlowLaunch]);
